
export const appCred = { 
    buildVersion : '1.0',
    //appUrl : 'http://localhost:1905/',
    appUrl : 'https://hisapiemirateconnectuat.aku.edu/',
    appServer : 'VPCWEBAPP5'
};